import React, {Component} from 'react';
import {Modal, Button}  from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSyncAlt} from  '@fortawesome/free-solid-svg-icons';

import { renderLoader } from '../../Loading/loading';

import '../report-header.css'
import '../../commoninputs.css'
import './Swapdevice.css'

export default class SwapDevice extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      uncomm: undefined,
      comm: undefined,
      deviceId: "",
      errMsg: null,
      isLoading: false,
      loader: renderLoader(),
    }
    this.isDCAP = false;
    this.handleClose = this.handleClose.bind(this);
    this.swapContent = this.swapContent.bind(this);
    this.selectOne = this.selectOne.bind(this)
    this.deviceId = this.deviceId.bind(this)
    this.typing = this.typing.bind(this)
  }
  async componentDidMount() {
    this.setState({uncomm: [], comm: []})
  }
  async componentDidUpdate(prevProps) {
    if (this.props.show && prevProps.show !== this.props.show) {
      this.setState ({errMsg: "", isLoading: false})
    }
  }
  typing (event) {
    this.setState({deviceId: event.target.value})
  }

  validateDevice () {
    const re = /^\d{11}$/;
    if (!re.test(this.state.deviceId)) {
      this.setState ({errMsg: "Replacement AC must be 11 numeric characters"})
      return false;
    }
    else {
      this.setState({errMsg: null})
      return true
    }
  }
  handleClose(event) {
    const swapWanted = event?.target?.id === 'ok'
    if (!swapWanted || this.props.device.length !== 11) {
      this.props.onHide(false)
      return
    }
    if (this.validateDevice()) {
      //const comm = this.props?.isCommissioned && this.props.isCommissioned(this.state.deviceId)
      if (typeof this.props.onHide === 'function')
        this.setState ({isLoading: true})
        this.props.onHide(swapWanted, this.state.deviceId);
    }
  }
  selectOne() {
    const ac = this.props?.device ?? "" 
    return ("Something's gone wrong. The original access code "+ac+" is incorrect")
  }
  renderModal (bodyContent) {
    const title = "Swap DCAPs"
    return(
      <Modal show={this.props.show ?? false} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='dcapbody'>
          {bodyContent()}
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" id='cancel' onClick={this.handleClose} disabled={this.state.isLoading}>Cancel</Button>
          <span>&nbsp;</span>
          <Button className="custom-std-btn" id='ok' onClick={this.handleClose} disabled={this.state.isLoading}>Ok</Button>
        </Modal.Footer>
      </Modal>
    )
  }
  deviceId (newValue) {
    this.setState({deviceId: newValue})
  }
  swapContent () {
    if (this.state.isLoading)
      return this.state.loader
    const startDevice = this.props?.device ?? ""
    const p1 = <span className="swapAC">Old Access Code {startDevice}</span>
    const p2 = this.swapInput()
    return this.renderSwap(p1, p2)
  }
  swapInput () {
    return (
      <label className={"inputPair"}>Replacement AC
        <input type="text" id="deviceid" name="deviceid" placeholder='Enter New AC' value={this.state.deviceId} onChange={this.typing}/>
      </label>
    )
  }

  renderSwap(col1, col3) {
    return (
      <div className="dcapwrapper">
        <div className="swapone">{col1}</div>
        <div className="swaptwo"><FontAwesomeIcon icon={faSyncAlt} color='#333' size="3x" /></div>
        <div className="swapthree">{col3}</div> 
      </div>
    )
  }
  render() {
    const dev = this.props?.device
    if (!dev || dev.length !== 11)
      return (this.renderModal(this.selectOne));

    return(this.renderModal(this.swapContent))
  }
}  